<template>
  <div class="use-agreement">
    <h3>服务使用协议</h3>
    <p>欢迎您阅读《“数科金云”平台服务协议》（以下简称“本协议”）。</p>
    <p>本协议是关于您（以下称“您”、“用户”）使用“数科金云”平台（以下简称“本程序”或“数科金云”）时，约定您权利义务的有效协议。重庆数科金云科技有限公司（以下简称“我公司”）按照本协议的规定及其不时发布的操作规则提供基于互联网以及移动网的金融信息服务（以下简称“服务“），为获得服务，服务使用人（以下简称“用户”或“您”）应当基于了解本协议全部内容，数科金云授予您软件产品的使用权并提供此合同所标的相关服务。为此双方在平等互利的基础上，遵循诚实信用的原则，通过友好协商达成如下使用协议:</p>
    <p>一、软件产品</p>
    <p>我公司许可您使用的软件产品: 数科金云平台</p>
    <p>二、质量标准</p>
    <p>我公司保证所许可的软件产品符合中华人民共和国有关法律、法规规定。并向您提供本合同所标的相关服务内容。</p>
    <p>三、软件版权及使用权</p>
    <p>本合同许可的是软件使用权，许可使用的软件产品版权属我公司所有，并受《中华人民共和国著作权法》和其他有关法律、法规的保护。</p>
    <p>您按本合同条款规定支付合同书上所列软件产品的全部软件使用许可费，我公司授予您上述软件产品的合法使用权并提供本合同标的相关服务内容。</p>
    <p>四、软件使用许可及服务费</p>
    <p>您向我公司支付的是技术服务费，服务费根据在平台开展的业务量进行计算，具体金额以沟通后双方确认为准。</p>
    <p>五、付款</p>
    <p>从合同签订之日起计算十个工作日内您须向我公司一次性付清本合同签订的软件使用许可及相关服务费。</p>
    <p>六、交货地点</p>
    <p>交货地点:线上交付</p>
    <p>七、限制规定</p>
    <p>1、我公司许可您使用的软件产品，只限于您本身使用，未经我公司书面同意，您不得将协议项下的权利或信息转让给任何第三方，包括您的关联公司。</p>
    <p>2、未经我公司书面同意，您不得将授予的软件使用权进行出租、销售、转让或非存档目的的拷贝及其他商业用途。</p>
    <p>3、未经我公司书面授权，您不得对软件产品进行修改、反编译、反汇编或其他任何反向工程。</p>
    <p>八、服务</p>
    <p>1、在合同有效期内，您享有以下服务内容:</p>
    <p>(1)我公司向您提供平台软件。</p>
    <p>(2)我公司可以解决您使用软件过程中由于软件自身出现的问题或操作不当等问题提供电话咨询服务。</p>
    <p>九、软件非保证范围</p>
    <p>我公司所许可使用的软件产品，因下述原因引发的软件问题不在本保证的范围内:</p>
    <p>1、您使用的第三方软件产品出错。</p>
    <p>2、硬件或网络出错。</p>
    <p>3、您使用非正版系统软件或网络等。</p>
    <p>十、权利保留</p>
    <p>在您完全履行其合同义务之前，我公司应当保留对本合同下标的物(包括软件使用权及相关服务)的所有权利。</p>
    <p>十一、违约责任</p>
    <p>按《中华人民共和国合同法》有关规定，任何一方违反本合同规定，造成本合同不能执行，须向另一方支付违约金，违约金金额为本合同金额的20%。</p>
    <p>十二、商业秘密</p>
    <p>除非得到另一方的书面许可，双方均不得将本合同中的内容及在本合同执行过程中获得的对方的商业信息向任何第三方泄露。</p>
    <p>十三、解决纠纷方式</p>
    <p>所有由本合同产生的争议，双方应当友好协商解决。如不能通过友好协商解决争议，任何一方均可将此争议提交仲裁机构仲裁。</p>
    <div class="company-name">
      <p>重庆数科金云科技有限公司</p>
      <p>2022年3月30日</p>
    </div>
  </div>
</template>

<script>
// import { Toast } from "vant";
export default {
  props: {
    isTop: Boolean
  },
  data() {
    return {}
  },
  mounted() {
    // 滚动监听
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    handleScroll() {
      let doc=document.getElementsByClassName('van-popup')[0]
      if(doc.scrollTop+doc.clientHeight>=doc.scrollHeight){
        this.$emit('changeisTop','new isTop')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.use-agreement {
  padding: 10px 15px;
  line-height: 2;
  text-indent: 2em;
  font-size: 15px;
  font-family: PingFang SC;
  background: #fff;
  h3 {
    text-align: center;
    padding: 10px;
  }
  .company-name {
    width: auto;
    margin: 40px 0;
    text-align: right;
  }
}
</style>